

























import { Vue, Component, Prop } from 'vue-property-decorator';
import RaceChart from '../components/RaceChart.vue';
import RaceTable from '../components/RaceTable.vue';
import RaceData from '../types/RaceData';
import * as RaceService from '../services/RaceService';

@Component({
  components: { RaceChart, RaceTable },
})
export default class Race extends Vue {
  raceData: RaceData | null = null;

  async mounted() {
    const raceId = this.$route.params.race_id;
    const raceData = await RaceService.getRace(raceId);
    console.log(raceData);
    raceData.results.sort((a, b) => a.position - b.position);
    raceData.results.forEach((result) => {
      result.driverName = result.driverName.substr(3);
      result.positionsGained = result.startPosition - result.position;
    });
    this.raceData = raceData;
  }
}
